// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__KmUcF","wrapper":"Switch_wrapper__HB5Ob","switch":"Switch_switch__+qmMN"};